<template>
    <div class="wrap">
        <div class="hd-bg">
            <div class="header">
                <div class="left"><a href="javascript:;" class="btn return" @click="$router.back()"></a></div>
                <div class="right"><a href="javascript:;" class="btn tel" @click="telConfirm"></a><a href="javascript:;" class="btn user" @click="checkLogined"></a></div>
                <!-- <div class="center"><router-link to="/">楼盘详情</router-link></div> -->
                <div class="center">楼盘详情</div>
            </div>
        </div>
        <div class="t-btn">
            <h1>{{building_info.building_name}}</h1>
            <div v-if="building_info.rent_sale_formal" class="t-status">{{building_info.rent_sale_formal}}</div>
        </div>
        <div class="btns-wrap">
            <div class="new-n" v-if="building_info.labels[0]">
                {{building_info.labels[0].label}}
            </div>
            <div class="zhineng" v-if="building_info.labels[1]">
                {{building_info.labels[1].label}}
            </div>
            
            <div class="shuzimeiti" v-if="building_info.labels[2]">
                {{building_info.labels[2].label}}
            </div>
            <div class="high-jishu" v-if="building_info.labels[3]">
                {{building_info.labels[3].label}}
            </div>
        </div>
        <p class="main-desc" v-html="building_info.description">
       <!-- {{building_info.description}} -->
        </p>
        <div class="pro-list">
            <div class="p-title">项目概况</div>
            <ul class="data-wrap">
                <li>
                    <div class="label">租售价格</div>
                    <div class="content">{{building_info.rent_sale_price}}</div>
                </li>
                <li>
                    <div class="label">项目地址</div>
                    <div class="content">{{building_info.address}}</div>
                </li>
                <li v-if="building_info.subway_steps">
                    <div class="label">地铁线路</div>
                    <div class="content">{{building_info.subway_steps}}</div>
                </li>
                <li v-if="building_info.districtname&&building_info.districtname!=='-'">
                    <div class="label">所属商圈</div>
                    <div class="content">{{building_info.districtname}}</div>
                </li>
                 <li v-if="building_info.developmentzone">
                    <div class="label">所属开发区</div>
                    <div class="content">{{building_info.developmentzone}}</div>
                </li>
                 <li>
                    <div class="label">产权年限</div>
                    <div class="content">{{building_info.property_year}}</div>
                </li>
                 <li>
                    <div class="label">可否注册公司</div>
                    <div class="content">{{building_info.can_register}}</div>
                </li>
                 <li>
                    <div class="label">招商电话</div>
                    <div class="content">{{building_info.merchants_call_400}}</div>
                </li>
                 <li>
                    <div class="label">开发公司</div>
                    <div class="content">{{building_info.development_co}}</div>
                </li>
                 <li>
                    <div class="label">建筑面积</div>
                    <div class="content">{{building_info.building_area}}</div>
                </li>
                 <li>
                    <div class="label">楼栋数</div>
                    <div class="content">{{building_info.building_number}}</div>
                </li>
                 <li>
                    <div class="label">土地性质</div>
                    <div class="content">{{building_info.building_tudi_type}}</div>
                </li>
                 <li>
                    <div class="label">施工阶段</div>
                    <div class="content">{{building_info.construction_phase}}</div>
                </li>
            </ul>
        </div>
        <div class="main-params">
            <div class="title">主要参数</div>
            <div class="row-wrap">
                <div v-if="building_info.param_xmts" class="col-item">
                   <div class="img-wrap">
                        <img src="../assets/images/pic1.png" alt="">
                   </div>
                   <div class="img-desc">
                       {{building_info.param_xmts}}
                   </div>
                </div>
                <div class="col-item" v-if="building_info.param_area">
                    <div class="img-wrap">
                        <img src="../assets/images/checkbox.png" alt="">
                    </div>
                    <div class="img-desc">
                       {{building_info.param_area}}m²
                    </div>
                </div>
                <div class="col-item" v-if="building_info.param_lcs">
                    <div class="img-wrap">
                        <img src="../assets/images/order.png" alt="">
                    </div>
                    <div class="img-desc">
                        {{building_info.param_lcs}}
                    </div>
                </div>
                 <div class="col-item" v-if="building_info.param_kffg">
                   <div class="img-wrap">
                        <img src="../assets/images/pic4.png" alt="">
                   </div>
                   <div class="img-desc">
                       {{building_info.param_kffg}}
                   </div>
                </div>
                <div class="col-item" v-if="building_info.param_bzcg">
                    <div class="img-wrap">
                        <img src="../assets/images/pic7.png" alt="">
                    </div>
                    <div class="img-desc">
                     {{building_info.param_bzcg}}
                    </div>
                </div>
                <div class="col-item" v-if="building_info.param_cydw">
                    <div class="img-wrap">
                        <img src="../assets/images/pic5.png" alt="">
                    </div>
                    <div class="img-desc">
                        {{building_info.param_cydw}}
                    </div>
                </div>
                 <div class="col-item"  v-if="building_info.param_zxzk">
                   <div class="img-wrap">
                        <img src="../assets/images/tools.png" alt="">
                   </div>
                   <div class="img-desc">
                       {{building_info.param_zxzk}}
                   </div>
                </div>
                <div class="col-item" v-if="building_info.param_yqfw">
                    <div class="img-wrap">
                        <img src="../assets/images/user.png" alt="">
                    </div>
                    <div class="img-desc">
                     {{building_info.param_yqfw}}
                    </div>
                </div>
                <div class="col-item" v-if="building_info.param_zclx">
                    <div class="img-wrap">
                        <img src="../assets/images/book.png" alt="">
                    </div>
                    <div class="img-desc">
                      {{building_info.param_zclx}}
                    </div>
                </div>
                  <div class="col-item" v-if="building_info.param_yqjb">
                   <div class="img-wrap">
                        <img src="../assets/images/medal.png" alt="">
                   </div>
                   <div class="img-desc">
                      {{building_info.param_yqjb}}
                   </div>
                </div>
                <div class="col-item" v-if="building_info.param_rzsj">
                    <div class="img-wrap">
                        <img src="../assets/images/time.png" alt="">
                    </div>
                    <div class="img-desc">
                       {{building_info.param_rzsj}}
                    </div>
                </div>
            </div>
        </div>
        <div class="tuijian">
           <div class="top">
               <div class="title">
                        楼盘推荐
                </div>
                <div class="more" @click="entermore('tuijian')"><span>查看更多</span><van-icon name="arrow" /></div>
           </div>
          
          
           <div class="fang-wrap" @click="entermore('loupandetail',item)" :key="item.id" v-for="item in buildingPushList">
               <div class="left">
                   <img :src="item.url" alt="">
               </div>
               <div class="right">
                    <div class="status-wrap">
                        <div class="status">在租</div>
                        <div class="title">{{item.building_name}}</div>
                    </div>
                    <div class="p-location">
                        <!-- <span class="place">北京</span>
                        <span class="location">大兴区</span> -->
                        {{item.area_name}}
                    </div>
                    <div class="price">
                        <!-- <span class="big">2.3</span>
                        <span>元/平方米/天</span> -->
                        {{item.price_explain}}
                    </div>
                    <div class="btn-group">
                        <div class="item" :key="list.label" v-for="list in item.labels">
                            {{list.label}}
                        </div>
                    </div>
               </div>
           </div>
        </div>
         <Footer></Footer>
    </div>
</template>
<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { SwipeCell, Toast, List,Dialog,Icon} from 'vant'
    export default {
        name: "ProblemList",
        data: function () {
            return {
                 downPath:'',
                building_info:{
                    labels:[],
                    positioning:''
                },
                buildingPushList:[]
            }
        },
        filters: {
            FormatTime (timestamp) {
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
                    return Y+M+D
            }
        },
        components: {
             [Dialog.name]: Dialog,
             [Icon.name]:Icon,
            Header, Footer
        },
        created(){
             this.downPath = this.api.downPath;
            this.getData()
        },
        mounted(){
            
        },
        methods: {
            entermore(val,item){
                switch(val){
                    case 'tuijian':
                        this.$router.push({
                            path: '/PropertyList'
                        })
                    break;
                    case 'loupandetail':
                        this.$router.push({
                            path: '/Property',
                            query: {
                                id: item.building_id
                            }
                        })
                    break;
                }
            },
            getData(){
                var that = this;
                 let id=that.$route.query.id
                that.api.getHousedesc({
                    building_id:id
                }).then(function(res){
                    that.building_info=res.building_info
                   that.buildingPushList=res.buildingPushList.map(item=>{
                       item.url=that.downPath+""+item.main_img
                       return item
                   })
                })
            },
            checkLogined () {
                var that = this;
                that.api.getUserInfo().then(function(res){
                    if (res.status == 1) {
                        that.$router.push('UserCenter')
                    } else {
                        that.$router.push('Login')
                    }
                })
            },
            telConfirm () {
                Dialog.confirm({
                    title: '400转接',
                    message: '',
                    confirmButtonText: '确定'
                }).then(() => {
                    window.location.href = "tel:4000080960";
                }).catch(()=>{});
            }
          
          
        }
    }
</script>

<style lang="scss" scoped>
    @import "./common.scss";
    .hd-bg {height: 1rem;}

    .header {
        position: fixed;top: 0;left: 0;width: 100%;height: 1rem;z-index: 100;
        background-color: #343434;line-height: 1rem;text-align: center;
    }
    .header .btn {
        display: inline-block;vertical-align: middle;width: .36rem;height: .36rem;margin: 0 .15rem;
        background-repeat: no-repeat;background-position: center center;-webkit-background-size: contain;background-size: contain;
    }
    .header .return {background-image: url('../assets/images/icon-return.png');}
    .header .user {background-image: url('../assets/images/icon-head-user.png');}
    .header .tel {background-image: url('../assets/images/icon-head-tel.png');}
    .header .left {
        position: absolute;top: 0;left: .15rem;
    }
    .header .right {
        position: absolute;top: 0;right: .15rem;
    }
    .header .center {
        position: relative;
        display: inline-block;
        font-size: .36rem;color: #ffffff;
    }
    .header .city {
        position: absolute;left: 100%;top: 50%;margin: -.7em .1rem 0;
        white-space: nowrap;font-size: .6em;line-height: 2;
        padding-right: .2rem;background: url("../assets/images/icon-sel3.png") no-repeat right center;-webkit-background-size: .15rem;background-size: .15rem;
    }
    .main-params .title{
        padding:px2rem(6px);
    }
    .main-params .img-desc{
        width:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size:px2rem(7px);
        padding:px2rem(6px) 0;
        text-align: center;
        font-size:px2rem(px);
    }
    .main-params .img-wrap img{
        width:auto;
        height:px2rem(27px);
        margin:0 auto;
        display:block;
    }
    .main-params .row-wrap{
        padding:px2rem(6px) 0;
        display:flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .main-params .col-item{
        position:relative;
        width:33%;
        height:px2rem(60px)
    }
    .main-params .title{
        font-size:px2rem(12.84px);
    }
   
    .pro-list .p-title{
        padding:px2rem(6px) 0;
        font-size:px2rem(12.84px)
    }
    .data-wrap li{
        font-size:px2rem(11px);
        line-height:px2rem(18px);
        display:flex;
    }
    
    .data-wrap .label{
        font-size:px2rem(10.05px);
        color:#7e8386;
        width:px2rem(78px);
    }
    .data-wrap .content{
        font-size:px2rem(10.05px);
        flex:1;
        color:#1f1f1f;
    }
    .main-params{
        margin-top:px2rem(10px);
        padding:px2rem(16px) px2rem(14px);
        background:#fff;
    }
    .pro-list{
        margin-top:px2rem(10px);
        padding:px2rem(16px) px2rem(14px);
        background:#fff;
    }
    .main-desc{
        font-size:px2rem(8.33);
        color:#1E1E1E;
        padding:px2rem(10px) px2rem(14px);
        background:#fff;
        text-align: justify;
        line-height:px2rem(16px);
    }
    .btns-wrap{
        padding:px2rem(0px) px2rem(14px);
        background:#fff;
    }
     .shuzimeiti{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        margin-left:px2rem(3px);
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#6da2eb;
        font-size:px2rem(8.21px);
    }
    .high-jishu{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        margin-left:px2rem(3px);
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#f3806b;
         font-size:px2rem(8.21px);
    }
    .new-n{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#ff8487;
         font-size:px2rem(8.21px);
    }
    .zhineng{
        display:flex;
        margin-left:px2rem(3px);
        padding:0 px2rem(5px);
        justify-content: center;
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#4cb41f;
         font-size:px2rem(8.21px);
    }
    .new-n{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#ff8487;
    }
    .btns-wrap{
        display:flex;
    }
    .wrap{
        background:#fafafa;
    }
    .t-btn{
        background:#fff;
        padding:px2rem(10px) px2rem(14px);
        display:flex;
        align-items: center;
    }
    .t-btn h1{
        font-size:px2rem(14.61px);
        color:#333;
    }
    .t-status{
        margin-left:px2rem(3px);
        padding:0 px2rem(5px);
        display:flex;
        justify-content: center;
        align-items: center;
        border-radius:px2rem(3px);
        color:#fff;
        height:px2rem(12.33px);
        background:#fe0000;
         font-size:px2rem(8.29px);
    }
    .fang-wrap .p-location{
         height:px2rem(14px);
        display:flex;
        align-items: center;
        font-size:px2rem(9px)
    }
   .fang-wrap .price{
       padding:px2rem(3px);
       font-size:px2rem(7.5px);
        color:#ff0100;
    }
    .fang-wrap .big{
        font-size:px2rem(15px);
        font-weight:bold;
    }
    .fang-wrap .btn-group{
        display:flex;
        align-items: center;
    }
     .fang-wrap .btn-group .item{
       color:#336094;
       border:px2rem(1px) solid #336094;
        margin-right:px2rem(4px);
        height:px2rem(13px);
        display:flex;
        align-items: center;
        padding:0 px2rem(5px);
        font-size:px2rem(7.64px)
    }
     .fang-wrap .place{
        margin-right:px2rem(6px);
    }
    .fang-wrap .status-wrap{
        display:flex;
        align-items: center;
    }
   .fang-wrap .title{
        font-size:px2rem(10px)!important;
        font-weight:bold;
    }
    .fang-wrap .status{
        background:#fe0000;
        height:px2rem(13px);
        margin-right:px2rem(4px);
        display:flex;
        justify-content: center;
        align-items: center;
        width:px2rem(26.67px);
        font-size:px2rem(8.37px);
        color:#fff;
    }
    .fang-wrap{
        display:flex;
        margin-bottom:px2rem(8px);
    }
    .fang-wrap .left{
        margin-top:px2rem(1.8px);
        margin-right:px2rem(10.67px);
        width:px2rem(104px);
        height:px2rem(77.67px);
        border-radius:px2rem(3px);
    }
    .fang-wrap .left img{
        width:100%;
        height:100%;
    }
    





     .tuijian .title{
        font-size:px2rem(15.38px);
    }
    .tuijian .more{
        color:#9a9da1;
        font-size:px2rem(10px);
        display:flex;
        align-items: center;
    }
    .tuijian .top{
        display:flex;
        padding-bottom:px2rem(14px);
        justify-content: space-between;
    }
    .tuijian{
        margin-top:px2rem(10px);
        padding:px2rem(16px) px2rem(14px);
    }
</style>
